/*!

=========================================================
* Material Dashboard React - v1.8.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// @material-ui/icons
// import Dashboard from "@material-ui/icons/Dashboard";
// import Person from "@material-ui/icons/Person";
// import LibraryBooks from "@material-ui/icons/LibraryBooks";
// import BubbleChart from "@material-ui/icons/BubbleChart";
// import LocationOn from "@material-ui/icons/LocationOn";
// import Notifications from "@material-ui/icons/Notifications";
import ArchiveIcon from "@material-ui/icons/Archive";
import Unarchive from "@material-ui/icons/Unarchive";
import ConfirmationNumberIcon from "@material-ui/icons/ConfirmationNumber";
// import Language from "@material-ui/icons/Language";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
// import CallReceivedIcon from '@material-ui/icons/CallReceived';
// import StarsIcon from '@material-ui/icons/Stars';
// core components/views for Admin layout
// import DashboardPage from "views/Dashboard/Dashboard";
import VaultList from "views/VaultList/VaultList";
// import OutboxList from "views/Outbox/OutboxList";
import InboxList from "views/Inbox/InboxList";
import Approval from "views/Approval/InboxList";
import AccessList from "views/Access/AccessList";
import ClaimNFT from "views/ClaimNFT";

// import Typography from "views/Typography/Typography";
// import Icons from "views/Icons/Icons";
// import Maps from "views/Maps/Maps";
// import NotificationsPage from "views/Notifications/Notifications";
// import UpgradeToPro from "views/UpgradeToPro/UpgradeToPro";
// // core components/views for RTL layout
// import RTLPage from "views/RTLPage/RTLPage";

const dashboardRoutes = [
  {
    path: "/vault",
    name: "My Vault",
    description: "View The Tokens You Own",
    rtlName: "قائمة الجدول",
    icon: AccountBalanceIcon,
    component: VaultList
    // layout: "/admin"
  },
  // {
  //   path: "/creations",
  //   name: "My Creations",
  //   description: "View The Tokens You Created",
  //   rtlName: "قائمة الجدول",
  //   icon: FingerprintIcon,
  //   component: CreationList,
  //   // layout: "/admin"
  // },
  {
    path: "/inbox",
    name: "My Inbox",
    rtlName: "قائمة الجدول",
    icon: ArchiveIcon,
    component: InboxList
    // layout: "/admin"
  },
  {
    path: "/approvals",
    name: "Approval Requests",
    rtlName: "قائمة الجدول",
    icon: ConfirmationNumberIcon,
    component: Approval
    // layout: "/admin"
  },
  {
    path: "/access",
    name: "Access Consents",
    rtlName: "قائمة الجدول",
    icon: Unarchive,
    component: AccessList
    // layout: "/admin"
  },
  {
    path: "/claim",
    name: "Claim",
    rtlName: "قائمة الجدول",
    icon: Unarchive,
    component: ClaimNFT
    // layout: "/admin"
  }
  // {
  //   path: "/outbox",
  //   name: "My Outbox",
  //   rtlName: "قائمة الجدول",
  //   icon: Unarchive,
  //   component: OutboxList,
  //   // layout: "/admin"
  // },
  // {
  //   path: "/mintToken",
  //   name: "Mint Token",
  //   description: "Create a Token from Our Minter",
  //   rtlName: "ملف تعريفي للمستخدم",
  //   icon: GavelIcon,
  //   component: MintTokenPage,
  //   // layout: "/admin"
  // },
  // {
  //   path: "/xdrSubmitter",
  //   name: "Submit XDR",
  //   rtlName: "ملف تعريفي للمستخدم",
  //   icon: ConfirmationNumberIcon,
  //   component: MintTokenPage,
  //   // layout: "/admin"
  // },
  // {
  //   path: "/typography",
  //   name: "Typography",
  //   rtlName: "طباعة",
  //   icon: LibraryBooks,
  //   component: Typography,
  //   layout: "/admin"
  // },
  // {
  //   path: "/stats",
  //   name: "Statistics",
  //   rtlName: "لوحة القيادة",
  //   icon: Dashboard,
  //   component: DashboardPage,
  //   // layout: "/admin"
  // }
  // {
  //   path: "/typography",
  //   name: "Typography",
  //   rtlName: "طباعة",
  //   icon: LibraryBooks,
  //   component: Typography,
  //   layout: "/admin"
  // },
  // {
  //   path: "/icons",
  //   name: "Icons",
  //   rtlName: "الرموز",
  //   icon: BubbleChart,
  //   component: Icons,
  //   layout: "/admin"
  // },
  // {
  //   path: "/maps",
  //   name: "Maps",
  //   rtlName: "خرائط",
  //   icon: LocationOn,
  //   component: Maps,
  //   layout: "/admin"
  // },
  // {
  //   path: "/notifications",
  //   name: "Notifications",
  //   rtlName: "إخطارات",
  //   icon: Notifications,
  //   component: NotificationsPage,
  //   layout: "/admin"
  // },
  // {
  //   path: "/rtl-page",
  //   name: "RTL Support",
  //   rtlName: "پشتیبانی از راست به چپ",
  //   icon: Language,
  //   component: RTLPage,
  //   layout: "/rtl"
  // },
  // {
  //   path: "/upgrade-to-pro",
  //   name: "Upgrade To PRO",
  //   rtlName: "التطور للاحترافية",
  //   icon: Unarchive,
  //   component: UpgradeToPro,
  //   layout: "/admin"
  // }
];

export default dashboardRoutes;
